import _ from 'lodash';
import React from 'react';
import { Switch, Route } from 'react-router-dom'; // import the react-router-dom components
import NavigationConfig, { Appbars } from '.';
import { RequireAuth, WithNavbar } from '../middlewares';
import DashboardIcon from '@material-ui/icons/Dashboard';
import EventIcon from '@material-ui/icons/Event';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import AssignmentReturnedOutlinedIcon from '@material-ui/icons/AssignmentReturnedOutlined';
import PersonIcon from '@material-ui/icons/Person';
import PaymentIcon from '@material-ui/icons/Payment';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing';
import NotificationImportantOutlinedIcon from '@material-ui/icons/NotificationImportantOutlined';

interface IProps {
  routes: Routes[];
}

interface Routes {
  exact: boolean;
  path: string;
  component: any;
  roles: number[];
}

const StackNavigator = ({ routes }: IProps) => {
  return (
    <Switch>
      {routes.map((route, i) => (
        <Route
          key={i}
          exact={route.exact}
          path={route.path}
          render={() => (
            <RequireAuth Component={route.component} roles={route.roles} />
          )}
        />
      ))}
    </Switch>
  );
};

export const MainRoutes = () => {
  return (
    <main>
      <Switch>
        {Appbars.map((route, i) => (
          <Route
            key={i}
            exact={false}
            path={'/'}
            render={() => (
              <WithNavbar
                include={route.include}
                exclude={route.exclude}
                select={route.select}
                Component={route.component}
              />
            )}
          />
        ))}
      </Switch>
    </main>
  );
};

/** CHANGE THIS TO PUT NEW ROUTES */
export const Routes = () => {
  return (
    <main>
      <StackNavigator
        routes={[
          { ...NavigationConfig.notificationsPage(), exact: true },
          { ...NavigationConfig.dashboardPage(), exact: true },
          { ...NavigationConfig.datatablesPage(), exact: true },
          { ...NavigationConfig.registerPage(), exact: true },
          { ...NavigationConfig.loginPage(), exact: true },
          { ...NavigationConfig.mainPage(), exact: true },
          { ...NavigationConfig.forgotPasswordPage(), exact: true },
          { ...NavigationConfig.resetPasswordPage(), exact: true },
          { ...NavigationConfig.mapsPage(), exact: true },
          { ...NavigationConfig.registrationDetailPage(), exact: true },
          { ...NavigationConfig.registrationListPage(), exact: true },
          { ...NavigationConfig.vatReturnsPage(), exact: true },
          { ...NavigationConfig.vatReturnDetailPage(), exact: true },
          { ...NavigationConfig.applicantsPage(), exact: true },
          { ...NavigationConfig.paymentsPage(), exact: true },
          { ...NavigationConfig.paymentInfoPage(), exact: true },
          { ...NavigationConfig.messageOutgoingPage(), exact: true },
          { ...NavigationConfig.messageIncomingPage(), exact: true },
          { ...NavigationConfig.registrationReceivedPage(), exact: true },
          { ...NavigationConfig.registrationReceivedDetailPage(), exact: true },
          { ...NavigationConfig.registrationRequest(), exact: true },
          { ...NavigationConfig.vatReturnRequest(), exact: true },
          { ...NavigationConfig.vatReturnRemindersPage(), exact: true },
          { ...NavigationConfig.paymentRemindersMsidPage(), exact: true },
          { ...NavigationConfig.paymentRemindersMsconPage(), exact: true },
          { ...NavigationConfig.vatReturnReceivedPage(), exact: true },
          { ...NavigationConfig.paymentReceivedPage(), exact: true },
          { ...NavigationConfig.remindersMsconReceivedPage(), exact: true },
          { ...NavigationConfig.remindersMsidReceivedPage(), exact: true },
          { ...NavigationConfig.reimbursementsReceivedPage(), exact: true },
          { ...NavigationConfig.reimbursementsPage(), exact: true },
          { ...NavigationConfig.reimbursementsMsconPage(), exact: true },
          { ...NavigationConfig.paymentCentralBankPage(), exact: true },
          { ...NavigationConfig.vatRatesPage(), exact: true },
          { ...NavigationConfig.rootPage(), exact: true }, // always last
        ]}
      />
    </main>
  );
};

interface ISubItems {
  path: string;
  title: string;
  component: React.FC;
  id: number;
  requiredRoles: Array<number>;
}
interface ISidebarConfig {
  title: string;
  path: string | null;
  Icon: React.FC;
  id: number;
  requiredRoles: Array<number> | null;
  component: React.FC | null;
  subItems?: ISubItems[];
}

export const SideBarConfig: ISidebarConfig[] = [
  {
    title: 'Dashboard',
    path: NavigationConfig.dashboardPage().path,
    Icon: () => <DashboardIcon />,
    id: 1,
    requiredRoles: NavigationConfig.dashboardPage().roles,
    component: NavigationConfig.dashboardPage().component,
  },
  {
    title: 'Applicants',
    requiredRoles: NavigationConfig.applicantsPage().roles,
    path: NavigationConfig.applicantsPage().path,
    Icon: () => <PersonIcon />,
    id: 2,
    component: NavigationConfig.applicantsPage().component,
  },
  {
    title: 'Notifications',
    path: NavigationConfig.notificationsPage().path,
    Icon: () => <NotificationsNoneOutlinedIcon />,
    requiredRoles: NavigationConfig.notificationsPage().roles,
    id: 3,
    component: NavigationConfig.notificationsPage().component,
  },
  {
    title: 'Registrations',
    path: NavigationConfig.registrationListPage().path,
    requiredRoles: NavigationConfig.registrationListPage().roles,
    Icon: () => <AssignmentOutlinedIcon />,
    id: 4,
    component: NavigationConfig.registrationListPage().component,
  },
  {
    title: 'VAT Returns',
    path: NavigationConfig.vatReturnsPage().path,
    requiredRoles: NavigationConfig.vatReturnsPage().roles,
    Icon: () => <AssignmentReturnedOutlinedIcon />,
    id: 5,
    component: NavigationConfig.vatReturnsPage().component,
  },
  {
    title: 'Payments',
    requiredRoles: NavigationConfig.paymentsPage().roles,
    path: NavigationConfig.paymentsPage().path,
    Icon: () => <PaymentIcon />,
    id: 6,
    component: NavigationConfig.paymentsPage().component,
    subItems: [
      {
        path: NavigationConfig.paymentsPage().path,
        title: 'Payments List',
        component: NavigationConfig.paymentsPage().component,
        id: 1,
        requiredRoles: NavigationConfig.paymentsPage().roles,
      },
      {
        path: NavigationConfig.paymentInfoPage().path,
        title: 'Payments Info',
        component: NavigationConfig.paymentInfoPage().component,
        id: 2,
        requiredRoles: NavigationConfig.paymentInfoPage().roles,
      },
      {
        path: NavigationConfig.paymentCentralBankPage().path,
        title: 'Central Bank',
        component: NavigationConfig.paymentCentralBankPage().component,
        id: 3,
        requiredRoles: NavigationConfig.paymentCentralBankPage().roles,
      },
      {
        path: NavigationConfig.reimbursementsPage().path,
        title: 'Reimburse MSID',
        component: NavigationConfig.reimbursementsPage().component,
        id: 4,
        requiredRoles: NavigationConfig.reimbursementsPage().roles,
      },
      {
        path: NavigationConfig.reimbursementsMsconPage().path,
        title: 'Reimburse MSCON',
        component: NavigationConfig.reimbursementsMsconPage().component,
        id: 5,
        requiredRoles: NavigationConfig.reimbursementsMsconPage().roles,
      },
    ],
  },
  {
    title: 'Reminders',
    requiredRoles: NavigationConfig.vatReturnRemindersPage().roles,
    path: null,
    Icon: () => <NotificationImportantOutlinedIcon />,
    id: 7,
    component: null,
    subItems: [
      {
        path: NavigationConfig.vatReturnRemindersPage().path,
        title: 'VAT Return',
        component: NavigationConfig.vatReturnRemindersPage().component,
        id: 1,
        requiredRoles: NavigationConfig.vatReturnRemindersPage().roles,
      },
      {
        path: NavigationConfig.paymentRemindersMsidPage().path,
        title: 'Payments MSID',
        component: NavigationConfig.paymentRemindersMsidPage().component,
        id: 2,
        requiredRoles: NavigationConfig.paymentRemindersMsidPage().roles,
      },
      {
        path: NavigationConfig.paymentRemindersMsconPage().path,
        title: 'Payments MSCON',
        component: NavigationConfig.paymentRemindersMsconPage().component,
        id: 3,
        requiredRoles: NavigationConfig.paymentRemindersMsconPage().roles,
      },
    ],
  },
  {
    title: 'Requests',
    requiredRoles: NavigationConfig.registrationRequest().roles,
    path: null,
    Icon: () => <CallMissedOutgoingIcon />,
    id: 8,
    component: null,
    subItems: [
      {
        path: NavigationConfig.registrationRequest().path,
        title: 'Registration',
        component: NavigationConfig.registrationRequest().component,
        id: 1,
        requiredRoles: NavigationConfig.registrationRequest().roles,
      },
      {
        path: NavigationConfig.vatReturnRequest().path,
        title: 'VAT Return',
        component: NavigationConfig.vatReturnRequest().component,
        id: 2,
        requiredRoles: NavigationConfig.vatReturnRequest().roles,
      },
    ],
  },
  {
    title: 'OMS Info',
    requiredRoles: NavigationConfig.registrationReceivedPage().roles,
    path: null,
    Icon: () => <CallReceivedIcon />,
    id: 9,
    component: null,
    subItems: [
      {
        path: NavigationConfig.registrationReceivedPage().path,
        title: 'Registrations',
        component: NavigationConfig.registrationReceivedPage().component,
        id: 1,
        requiredRoles: NavigationConfig.registrationReceivedPage().roles,
      },
      {
        path: NavigationConfig.vatReturnReceivedPage().path,
        title: 'VAT Returns',
        component: NavigationConfig.vatReturnReceivedPage().component,
        id: 2,
        requiredRoles: NavigationConfig.vatReturnReceivedPage().roles,
      },
      {
        path: NavigationConfig.paymentReceivedPage().path,
        title: 'Payments',
        component: NavigationConfig.paymentReceivedPage().component,
        id: 3,
        requiredRoles: NavigationConfig.paymentReceivedPage().roles,
      },
      {
        path: NavigationConfig.remindersMsconReceivedPage().path,
        title: 'Reminders MSCON',
        component: NavigationConfig.remindersMsconReceivedPage().component,
        id: 4,
        requiredRoles: NavigationConfig.remindersMsconReceivedPage().roles,
      },
      {
        path: NavigationConfig.remindersMsidReceivedPage().path,
        title: 'Reminders MSID',
        component: NavigationConfig.remindersMsidReceivedPage().component,
        id: 5,
        requiredRoles: NavigationConfig.remindersMsidReceivedPage().roles,
      },
      {
        path: NavigationConfig.reimbursementsReceivedPage().path,
        title: 'Reimbursements',
        component: NavigationConfig.reimbursementsReceivedPage().component,
        id: 6,
        requiredRoles: NavigationConfig.reimbursementsReceivedPage().roles,
      },
    ],
  },
  {
    title: 'Messages',
    requiredRoles: NavigationConfig.messageOutgoingPage().roles,
    path: null,
    Icon: () => <MailOutlineIcon />,
    id: 10,
    component: null,
    subItems: [
      {
        path: NavigationConfig.messageOutgoingPage().path,
        title: 'Message Outgoing',
        component: NavigationConfig.messageOutgoingPage().component,
        id: 1,
        requiredRoles: NavigationConfig.messageOutgoingPage().roles,
      },
      {
        path: NavigationConfig.messageIncomingPage().path,
        title: 'Message Incoming',
        component: NavigationConfig.messageIncomingPage().component,
        id: 2,
        requiredRoles: NavigationConfig.messageIncomingPage().roles,
      },
    ],
  },
  {
    title: 'VAT Rates',
    path: NavigationConfig.vatRatesPage().path,
    Icon: () => <AssignmentReturnedOutlinedIcon />,
    id: 11,
    requiredRoles: NavigationConfig.vatRatesPage().roles,
    component: NavigationConfig.vatRatesPage().component,
  },
  // {
  //   title: 'Registration Received',
  //   requiredRoles: NavigationConfig.registrationReceivedPage().roles,
  //   path: NavigationConfig.registrationReceivedPage().path,
  //   Icon: () => <CallReceivedIcon />,
  //   id: 9,
  //   component: NavigationConfig.registrationReceivedPage().component,
  // },
];
